export default {"src":"/bnb/_next/static/media/coin98wallet.bd76a008.svg","height":20,"width":20};